module.exports = __webpack_public_path__ + "img/hotdog-top-chizu.37fca143.png";